/** Английский словарь лендинга. Ключи — по типу русского словаря. */
import type { LandingSchema } from './ru'

const en: LandingSchema = {
  meta: {
    title: 'Hubario — the hub for your Telegram messages',
    description:
      'Hubario — the hub for your Telegram messages: every chat in one place, voice messages transcribed, mentions and AI analysis.',
    ogDescription:
      'Every chat in one place, voice messages transcribed, mentions and AI analysis.',
    ogLocale: 'en_US',
  },
  nav: {
    how: 'How it works',
    features: 'Features',
  },
  header: {
    login: 'Sign in',
    start: 'Start for free',
  },
  hero: {
    badge: 'Your Telegram, under control',
    title1: 'All your Telegram —',
    title2: 'in one hub',
    sub: 'Hubario collects your conversations: chats, groups, channels, voice messages. Nothing gets lost — and what matters goes to AI analysis.',
    ctaPrimary: 'Start for free',
    ctaSecondary: 'How it works',
  },
  how: {
    title: 'How it works',
    steps: [
      {
        title: 'Sign in with Google',
        text: 'Your account is created automatically on first sign-in — no cards, passwords or installs.',
      },
      {
        title: 'Connect Telegram',
        text: 'Scan a QR code in the Telegram app — your messages start syncing automatically.',
      },
      {
        title: 'Manage and analyze',
        text: 'Track the chats you need, find mentions, send selected conversations to AI analysis.',
      },
    ],
  },
  features: {
    title: 'Features',
    items: [
      {
        title: 'All chats in one place',
        text: 'Private dialogs, groups and channels — a single feed with search and filters.',
      },
      {
        title: 'Voice messages as text',
        text: 'Voice messages are stored and transcribed to text automatically.',
      },
      {
        title: 'Mentions never get lost',
        text: 'Every message where you were mentioned or replied to — in a dedicated view.',
      },
      {
        title: 'History and edits',
        text: 'Edited and deleted messages keep their original versions.',
      },
      {
        title: 'AI analysis packages',
        text: 'Pick chats and a period — get a digest: tasks, agreements, events.',
      },
      {
        title: 'Security',
        text: 'Telegram access is encrypted, your data belongs to you alone. Read-only — no actions on your behalf.',
      },
    ],
  },
  cta: {
    title: 'Try Hubario today',
    text: 'Sign in with Google in a minute, connect Telegram via a QR code.',
    button: 'Start for free',
  },
  footer: {
    tagline: 'hubario.com — the hub for your Telegram messages',
  },
}

export default en
